import { Fragment, ReactNode } from 'react';
import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { InSeasonSpecies } from '@domain/regulations/getInSeasonSpecies';
import { getSpeciesUrl } from '@domain/routes/urls';

export const renderLinkedSpecies = (species: InSeasonSpecies[]): ReactNode =>
  species.flatMap((s, i) => {
    const separator =
      i === 0 ? null : i === species.length - 1 && species.length > 1 ? ', and ' : ', ';
    const link = (
      <InternalLink
        key={s._id}
        to={getSpeciesUrl(s._id, s.displayName)}
        className="body-text-sm text-primary"
      >
        {s.displayName}
      </InternalLink>
    );
    return separator ? [<Fragment key={`sep-${s._id}`}>{separator}</Fragment>, link] : [link];
  });
